<template>
  <b-modal ref="travel-health-modal-ref" hide-footer hide-header :title="payload.title">
    <div class="vtd-modal-content">
      <div class="vtd-modal-header">
        <h5 class="vtd-modal-title">{{ menuObject.title }}</h5>
        <button @click="closeModal" type="button" class="close" aria-label="Close">
          <span aria-hidden="true"><i class="material-icons">&#xE5CD;</i></span>
        </button>
      </div>
      <div v-if="hasEntryRequirements" class="vtd-modal-body">
        <p>
          Should any mandatory vaccination certificates be required, these will
          be listed under Entry Requirements.
        </p> 
        <p>
          There will also likely be non-mandatory vaccinations you need to consider. Please visit
          <a href="https://travelhealthpro.org.uk/" target="_blank">Travel Health Pro</a>
          for information based on the destinations you plan to visit.
        </p>
        <p>
          Ensure you seek vaccination and travel health advice at least six
          weeks prior to travel from a qualified medical professional; either
          your GP or a specialist at a travel health clinic. They will be able
          to advise appropriate vaccination and travel health guidance
          considering you as an individual, your specific travel arrangements
          and your personal medical history. This is important as some
          vaccinations are not recommended for everyone.
        </p>
        <p>
          Travel health consultation appointments can be made with Trailfinders
          if you are within reach of our
          <a href="https://www.trailfinders.com/contact/appointment" target="_blank">Kensington Travel Clinic
          </a>
          in London.
        </p>
      </div>
      <div v-else class="vtd-modal-body">
        <div
          class="message"
          v-for="(msgBlock, index) in payload"
          :key="`health-${index}`"
        >
          <p v-show="msgBlock.title">{{ msgBlock.title }}</p>
          <div v-html="msgBlock.editedtext"></div>
        </div>
      </div>
      <div class="btn-wrap">
        <div class="vtd-modal-footer vtd-bg-faded vtd-flex-column">
          <small>This information was generated at:
            <strong class="return-date">{{ returnDate }}</strong></small>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import dayjs from '@/lib/dayjs'
import { mapState, mapGetters } from 'vuex'
import { loadVisaInfo } from '../visa/services'
import { getSite } from '@/lib/utilities'

export default {
  data() {
    return {
      hasEntryRequirements: false,
      menuObject: {},
      payload: [],
      messages: [],
    }
  },
  computed: {
    ...mapState(['booking']),
    ...mapGetters('booking', ['getCityCodes', 'getBookingNumber']),
    ...mapGetters({ essentialInfoMenu: 'essentialInfoMenu/getMenu' }),
    returnDate() {
      return dayjs().format('DD-MMM-YYYY HH:mm')
    },
  },
  methods: {
    async showModal(menuObject) {
      this.$refs['travel-health-modal-ref'].show()
      this.messages = this.getTravelHealthMessages()
      if (!menuObject || !menuObject.payload || menuObject.payload.length === 0) {
        return
      }
      this.menuObject = menuObject
      this.payload = menuObject.payload

      this.$store.dispatch('spinner/updateLoadingAction', true, { root: true })
      let payload
      for (const [index, item] of this.essentialInfoMenu.entries()) {
        if (item.partial === 'VisaRef') {
          payload = this.essentialInfoMenu[index].payload
        }
      }
      this.bookingEssentialInformationVisa = payload
      const visaPayload = {
        visa: this.bookingEssentialInformationVisa.visa_requirements,
        site: getSite(),
        clients: this.booking.bookingPassengers
          ? this.booking.bookingPassengers.map((passenger) => passenger)
          : [],
        bookno: this.getBookingNumber,
      }
      const res = await loadVisaInfo(visaPayload)
      if (res.data && res.data.hasEntryRequirements) {
        this.hasEntryRequirements = true
      }
      this.$store.dispatch('spinner/updateLoadingAction', false, {
        root: true,
      })
    },

    getTravelHealthMessages() {
      const essentialInfo = this.getEssentialInfo
      if (!essentialInfo || !Array.isArray(essentialInfo.menu)) {
        return []
      }
      const entry = essentialInfo.menu.find(
        (item) => item.cleantitle === 'open-modal-travel-health',
      )
      return entry && Array.isArray(entry.message) ? entry.message : []
    },

    closeModal() {
      this.$refs['travel-health-modal-ref'].hide()
    },
  },
}
</script>
<style lang="scss">
@import './style.scss';

.message {
  margin-bottom: 20px;
}

.travel-health-item {
  margin-bottom: 20px;
}

.travel-health-item-text {
  white-space: pre-line;
}
</style>
